import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Spinner, Table } from 'react-bootstrap';
import { api } from "../../../services/api";
import Swal from "sweetalert2";
import { FaEdit, FaArrowLeft, FaLink } from "react-icons/fa";

export default function ModalAssocBandeira({ show, onHide }) {
    const [loading, setLoading] = useState(false);
    const [view, setView] = useState('lista'); 
    const [associacoes, setAssociacoes] = useState([]);
    const [lookups, setLookups] = useState({ roteamentos: [], bandeirasSugeridas: [] });
    
    // ESTADO PARA OS FILTROS (Combobox)
    const [filtros, setFiltros] = useState({
        roteamento: '',
        bandeiraimp: '',
        bandflor: ''
    });

    const [form, setForm] = useState({
        roteamento: '',
        bandeiraimp: '',
        bandflor: ''
    });

    useEffect(() => {
        if (show) {
            listarAssociacoes();
            carregarRoteamentos();
            setView('lista');
            setFiltros({ roteamento: '', bandeiraimp: '', bandflor: '' });
        }
    }, [show]);

    const carregarRoteamentos = () => {
        api.get('/financeiro/conciliacao/roteamentos')
            .then(res => setLookups(prev => ({ ...prev, roteamentos: res.data })))
            .catch(err => console.error(err));
    };

    const listarAssociacoes = async () => {
        setLoading(true);
        try {
            const res = await api.get('/financeiro/conciliacao/associacoes');
            setAssociacoes(res.data || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleEditar = (item) => {
        setForm({
            roteamento: item.ROTEAMENTO || item.roteamento,
            bandeiraimp: item.BANDEIRAIMP || item.bandeiraimp,
            bandflor: item.BANDFLOR || item.bandflor || ''
        });
        api.get(`/financeiro/conciliacao/bandeiras?roteamento=${item.ROTEAMENTO || item.roteamento}`)
            .then(res => setLookups(prev => ({ ...prev, bandeirasSugeridas: res.data })));
        
        setView('formulario');
    };

    const handleSalvar = async () => {
        if (!form.bandflor) {
            Swal.fire("Atenção", "Selecione uma bandeira para associar", "warning");
            return;
        }
        setLoading(true);
        try {
            await api.post('/financeiro/conciliacao/associar', form);
            Swal.fire("Sucesso", "Associação realizada!", "success");
            listarAssociacoes();
            setView('lista');
        } catch (err) {
            Swal.fire("Erro", "Erro ao salvar associação", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleFiltroChange = (e) => {
        const { name, value } = e.target;
        setFiltros(prev => ({ ...prev, [name]: value }));
    };

    // FUNÇÃO PARA PEGAR VALORES ÚNICOS PARA OS COMBOBOX
    const getUniqueValues = (key) => {
        const values = associacoes.map(item => {
            const val = item[key] || item[key.toUpperCase()];
            return val || (key === 'bandflor' ? "Não associada" : "");
        });
        return [...new Set(values)].filter(v => v !== "").sort();
    };

    // LÓGICA DE FILTRAGEM
    const dadosFiltrados = associacoes.filter(item => {
        const rot = (item.roteamento || item.ROTEAMENTO || "").toLowerCase();
        const imp = (item.bandeiraimp || item.BANDEIRAIMP || "").toLowerCase();
        const flor = (item.bandflor || item.BANDFLOR || "Não associada").toLowerCase();

        return (
            (filtros.roteamento === "" || rot === filtros.roteamento.toLowerCase()) &&
            (filtros.bandeiraimp === "" || imp === filtros.bandeiraimp.toLowerCase()) &&
            (filtros.bandflor === "" || flor === filtros.bandflor.toLowerCase())
        );
    });

    return (
        <Modal show={show} onHide={onHide} centered size="lg" backdrop="static" scrollable>
            <Modal.Header closeButton className="bg-primary text-white p-2">
                <Modal.Title className="small fw-bold ms-2">
                    <FaLink className="me-2"/>ASSOCIAÇÃO DE BANDEIRAS
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="bg-light">
                {view === 'lista' ? (
                    <div className="table-responsive bg-white shadow-sm border rounded" style={{ maxHeight: '500px' }}>
                        <Table striped bordered hover size="sm" className="mb-0">
                            <thead className="table-dark small sticky-top">
                                <tr>
                                    <th>
                                        Roteamento
                                        <Form.Select 
                                            size="sm" 
                                            name="roteamento"
                                            className="mt-1 bg-dark text-white border-secondary shadow-none"
                                            style={{ fontSize: '0.75rem' }}
                                            value={filtros.roteamento}
                                            onChange={handleFiltroChange}
                                        >
                                            <option value="">(Todos)</option>
                                            {getUniqueValues('roteamento').map((v, i) => <option key={i} value={v}>{v}</option>)}
                                        </Form.Select>
                                    </th>
                                    <th>
                                        Bandeira (Importada)
                                        <Form.Select 
                                            size="sm" 
                                            name="bandeiraimp"
                                            className="mt-1 bg-dark text-white border-secondary shadow-none"
                                            style={{ fontSize: '0.75rem' }}
                                            value={filtros.bandeiraimp}
                                            onChange={handleFiltroChange}
                                        >
                                            <option value="">(Todos)</option>
                                            {getUniqueValues('bandeiraimp').map((v, i) => <option key={i} value={v}>{v}</option>)}
                                        </Form.Select>
                                    </th>
                                    <th>
                                        Associada a (Sistema)
                                        <Form.Select 
                                            size="sm" 
                                            name="bandflor"
                                            className="mt-1 bg-dark text-white border-secondary shadow-none"
                                            style={{ fontSize: '0.75rem' }}
                                            value={filtros.bandflor}
                                            onChange={handleFiltroChange}
                                        >
                                            <option value="">(Todos)</option>
                                            {getUniqueValues('bandflor').map((v, i) => <option key={i} value={v}>{v}</option>)}
                                        </Form.Select>
                                    </th>
                                    <th width="50" className="text-center align-middle">Ação</th>
                                </tr>
                            </thead>
                            <tbody className="small">
                                {loading ? (
                                    <tr><td colSpan="4" className="text-center p-3"><Spinner size="sm" /></td></tr>
                                ) : dadosFiltrados.map((item, i) => (
                                    <tr key={i}>
                                        <td>{item.roteamento || item.ROTEAMENTO}</td>
                                        <td>{item.bandeiraimp || item.BANDEIRAIMP}</td>
                                        <td className={(item.bandflor || item.BANDFLOR) ? "text-success fw-bold" : "text-danger italic"}>
                                            {item.bandflor || item.BANDFLOR || "Não associada"}
                                        </td>
                                        <td className="text-center">
                                            <Button variant="outline-primary" size="sm" onClick={() => handleEditar(item)}>
                                                <FaEdit />
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                                {!loading && dadosFiltrados.length === 0 && (
                                    <tr><td colSpan="4" className="text-center p-3 text-muted">Nenhum registro para o filtro selecionado.</td></tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                ) : (
                    <Form className="p-2">
                        <Button variant="link" size="sm" onClick={() => setView('lista')} className="mb-4 p-0 text-decoration-none fw-bold">
                            <FaArrowLeft className="me-2" /> VOLTAR PARA LISTA
                        </Button>

                        <Row className="g-3">
                            <Col md={6}>
                                <label className="small fw-bold">Roteamento</label>
                                <Form.Control size="sm" plaintext readOnly className="fw-bold border-bottom" value={form.roteamento} />
                            </Col>
                            <Col md={6}>
                                <label className="small fw-bold">Bandeira do Arquivo</label>
                                <Form.Control size="sm" plaintext readOnly className="fw-bold border-bottom" value={form.bandeiraimp} />
                            </Col>
                            <Col md={12}>
                                <label className="small fw-bold text-primary">Associar com a Bandeira do Sistema:</label>
                                <Form.Select 
                                    size="sm" 
                                    value={form.bandflor} 
                                    onChange={e => setForm({...form, bandflor: e.target.value})}
                                >
                                    <option value="">Selecione a bandeira correspondente...</option>
                                    {lookups.bandeirasSugeridas.map((b, idx) => (
                                        <option key={idx} value={b.bandeira || b}>{b.bandeira || b}</option>
                                    ))}
                                </Form.Select>
                            </Col>
                        </Row>
                    </Form>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" size="sm" onClick={onHide}>FECHAR</Button>
                {view === 'formulario' && (
                    <Button variant="primary" size="sm" onClick={handleSalvar} disabled={loading}>
                        {loading ? 'SALVANDO...' : 'CONFIRMAR ASSOCIAÇÃO'}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}